// extracted by mini-css-extract-plugin
export default {"container":"_20S7D1s"};